/**
 * Shared Onboarding API
 *
 * Common API functions used by both user and tenant onboarding flows.
 * These endpoints are identical for both flows.
 */

import type {
  OnboardingFlowResponse,
  TokenValidationResult,
} from '@/features/onboarding/types/onboarding.types';
import { unauthenticatedFetch } from './unauthenticated-fetch';

const ONBOARDING_API_BASE = '/user-portal-api/onboarding';

/**
 * Validate onboarding invitation token
 *
 * Used by both user and tenant onboarding flows.
 */
export async function validateOnboardingToken(
  token: string
): Promise<TokenValidationResult> {
  return unauthenticatedFetch<TokenValidationResult>(
    '/user-portal-api/invitations/validate',
    {
      method: 'POST',
      body: { token },
    }
  );
}

/**
 * Start onboarding flow
 *
 * Used by both user and tenant onboarding flows.
 */
export async function startOnboardingFlow(
  token: string
): Promise<OnboardingFlowResponse> {
  return unauthenticatedFetch<OnboardingFlowResponse>(
    `${ONBOARDING_API_BASE}/start`,
    {
      method: 'POST',
      body: { token },
    }
  );
}
